import { Component, OnInit } from '@angular/core';
import { AuthLoginService } from 'src/app/_services/users/auth-login.service';
import { UserServiceService } from 'src/app/_services/users/user-service.service';

@Component({
  selector: 'app-pin',
  templateUrl: './pin.component.html',
  styleUrls: ['./pin.component.scss']
})
export class PinComponent implements OnInit {

  user: any = {};
  success: boolean = false;
  error: boolean = false;
  message: string = '';
  showPinModal: boolean = false;
  newPin: string = '';
  submitted: boolean = false;
  isPinValid: boolean = true;

  constructor(
    private authService: AuthLoginService,
    private userService: UserServiceService
  ){}

  ngOnInit(): void {
    this.authService.userProfile().subscribe(
      (res) => {
        this.user = res.data;
        this.newPin = this.user.pin || ''; // Pre-fill newPin with current PIN if available
      }
    );
  }

  togglePinModal() {
    this.showPinModal = !this.showPinModal;
  }

  close() {
    this.showPinModal = false;
    this.newPin = this.user.pin || ''; // Reset newPin to current PIN
    this.submitted = false;
    this.isPinValid = true;
  }

  setPin() {
    this.submitted = true;
    this.isPinValid = this.validatePin(this.newPin);
    if (!this.isPinValid) {
      this.message = 'El PIN debe ser un número de 4 dígitos.';
      this.error = true;
      return;
    }
    this.userService.setPin(this.newPin).subscribe(
      (res) => {
        if (res.success) {
          this.message = 'PIN actualizado con éxito';
          this.success = true;
          this.user.pin = this.newPin; // Update local user object with new PIN
        } else {
          this.message = res.message || 'Error al actualizar el PIN';
          this.error = true;
        }
        this.close();
      },
      (error) => {
        console.error('Error al actualizar el PIN:', error);
        this.message = 'Error al actualizar el PIN';
        this.error = true;
        this.close();
      }
    );
  }

  validatePin(pin: string): boolean {
    return /^\d{4}$/.test(pin);
  }
}
